/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import * as yup from 'yup'


export const attributeModel = (intl) => {
    return yup.object().shape({
        type: yup.string().required(),
        value: yup.string().when('type', {
            is: 'integer',
            then: value => value.testInteger(intl.formatMessage({id: "asset.validation.expect.integer"})),
        }).when('type', {
            is: 'float',
            then: value => value.testFloat(intl.formatMessage({id: "asset.validation.expect.float"})),
        }).when('type', {
            is: 'date',
            then: value => value.testDate(intl.formatMessage({id: "asset.validation.expect.date"})),
        }),
    })
}

export const variantModel = () => {
    return yup.number()
        .required()
        .positive()
        .integer()
}

export const assetModel = (intl) => {
    const attributeSchema = attributeModel(intl);

    return yup.object().shape({
        name: yup.string()
            .required(intl.formatMessage({id: "asset.validation.name.required"}))
            .trim().min(3, intl.formatMessage({id: "asset.validation.name.minSize"}))
            .trim().max(50, intl.formatMessage({id: "asset.validation.name.maxSize"})),
        fleetId: yup.number()
            .typeError(intl.formatMessage({id: "asset.validation.fleetId.required"}))
            .positive(intl.formatMessage({id: "asset.validation.fleetId.required"}))
            .required(intl.formatMessage({id: "asset.validation.fleetId.required"})),
        attributes: yup.array().of(attributeSchema),
        ldiId: yup.number(intl.formatMessage({id: "asset.validation.ldiId.required"}))
            .required(intl.formatMessage({id: "asset.validation.ldiId.required"}))
            .positive(intl.formatMessage({id: "asset.validation.ldiId.required"}))
            .integer(intl.formatMessage({id: "asset.validation.ldiId.required"})),
        //variants: yup.array().of(variantSchema)
        //    .required(intl.formatMessage({id:"asset.validation.variant.required"}))
    })
}

export const assetModelHda = (intl) => {
    const attributeSchema = attributeModel(intl);
    const variantSchema = variantModel();

    return yup.object().shape({
        name: yup.string()
            .required(intl.formatMessage({id: "asset.validation.name.required"}))
            .trim().min(3, intl.formatMessage({id: "asset.validation.name.minSize"}))
            .trim().max(50, intl.formatMessage({id: "asset.validation.name.maxSize"})),
        fleetId: yup.number()
            .typeError(intl.formatMessage({id: "asset.validation.fleetId.required"}))
            .positive(intl.formatMessage({id: "asset.validation.fleetId.required"}))
            .required(intl.formatMessage({id: "asset.validation.fleetId.required"})),
        attributes: yup.array().of(attributeSchema),
        variants: yup.array().of(variantSchema)
            .required(intl.formatMessage({id: "asset.validation.variant.required"})),
        engineType: yup.string().nullable()
            .required(intl.formatMessage({id: "asset.validation.variant.engineType.required"})),
        engineModel: yup.string().nullable()
            .required(intl.formatMessage({id: "asset.validation.variant.engineModel.required"})),
        configuration: yup.string().nullable()
            .required(intl.formatMessage({id: "asset.validation.variant.configuration.required"})),
        platform: yup.string().nullable().required(intl.formatMessage({id: "asset.validation.variant.platform.required"})),
        ldiId: yup.number(intl.formatMessage({id: "asset.validation.ldiId.required"}))
            .required(intl.formatMessage({id: "asset.validation.ldiId.required"}))
            .positive(intl.formatMessage({id: "asset.validation.ldiId.required"}))
            .integer(intl.formatMessage({id: "asset.validation.ldiId.required"})),
    })
}

const testInteger = (msg) => {
    return yup.mixed().test({
        name: 'testInteger',
        exclusive: false,
        message: msg || '${path} must be an integer',
        params: {},
        test: function (value) {
            if (typeof value === 'undefined' || value === '') {
                return true;
            }
            const parsed = Number(value)
            return !isNaN(parsed) && Number.isInteger(parsed);
        },
    });
}

const testFloat = (msg) => {
    return yup.mixed().test({
        name: 'testFloat',
        exclusive: false,
        message: msg || '${path} must be a number',
        params: {},
        test: function (value) {
            if (typeof value === 'undefined' || value === '') {
                return true;
            }
            const parsed = Number(value)
            return !isNaN(parsed);
        },
    });
}

const testDate = (msg) => {
    return yup.mixed().test({
        name: 'testFloat',
        exclusive: false,
        message: msg || '${path} must be a date',
        params: {},
        test: function (value) {
            if (typeof value === 'undefined' || value === '') {
                return true;
            }
            const parsed = Date.parse(value)
            return !isNaN(parsed);
        },
    });
}

yup.addMethod(yup.string, 'testInteger', testInteger);
yup.addMethod(yup.string, 'testFloat', testFloat);
yup.addMethod(yup.string, 'testDate', testDate);